// globalStyles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    display: 'none';
    background-color: #f0f0f0;
    font-family: 'Roboto', sans-serif;
  }
  .showMe {
    display: 'block';
    color: red;
  }
  @media (max-width: 600px) {  // Adjust the maximum width as per your requirements
    .centerTextMobile {
      text-align: center;
    }
    .largeMarginMobile {
        margin-right: 10px;
        margin-left: 10px;
    }
    .mobile-video{
      height: 300px
    }
  }
`;

export default GlobalStyle;
